import { Feather } from "lucide-react";
import { Eyebrow, Reveal, SectionTitle } from "./Reveal";
import { ITINERARY } from "./data";

function DayBlock({ day, index }) {
  const flip = index % 2 === 1;
  return (
    <article
      data-testid={`itinerary-day-${day.day}`}
      className="relative grid items-center gap-10 py-14 md:grid-cols-2 md:gap-16 md:py-16"
    >
      <span
        className="absolute left-1/2 top-1/2 z-10 hidden h-14 w-14 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-4 border-forest bg-saffron font-serif text-xl italic text-forest md:flex"
        aria-hidden="true"
      >
        {day.day}
      </span>

      <div className={flip ? "md:order-2" : ""}>
        <Reveal>
          <p className="text-[11px] font-medium uppercase tracking-[0.3em] text-saffron">Day {day.day}</p>
          <h3 className="mt-3 font-serif text-3xl font-light leading-[1.15] text-ivory md:text-4xl">{day.title}</h3>
          <p className="mt-3 text-[11px] font-medium uppercase tracking-[0.22em] text-ivory/45">
            {day.drive ? `Drive: ${day.drive} · ` : ""}Overnight&nbsp;:&nbsp;{day.overnight}
          </p>
          <p className="mt-5 max-w-lg font-serif text-lg italic leading-[1.75] text-ivory/75">{day.text}</p>
          <ul className="mt-6 space-y-2.5">
            {day.bullets.map((b) => (
              <li key={b} className="flex items-center gap-3 text-[14px] text-ivory/80">
                <Feather className="h-3.5 w-3.5 shrink-0 text-saffron" strokeWidth={1.6} />
                {b}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>

      <div className={flip ? "md:order-1" : ""}>
        <Reveal delay={0.15}>
          <figure className="group overflow-hidden shadow-2xl shadow-black/30">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={day.image}
                alt={day.imageAlt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]"
              />
            </div>
          </figure>
        </Reveal>
      </div>
    </article>
  );
}

export default function Itinerary() {
  return (
    <section id="itinerary" data-testid="itinerary-section" className="bg-forest">
      <div className="mx-auto max-w-editorial px-6 py-24 md:px-10 md:py-32">
        <Reveal>
          <Eyebrow center>12 Days · 12 Stories</Eyebrow>
        </Reveal>
        <Reveal delay={0.12}>
          <SectionTitle before="Your Day-by-Day" accent="Journey" dark center className="mt-7" />
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mx-auto mt-7 h-px w-16 bg-saffron/40" aria-hidden="true" />
        </Reveal>

        <div className="mt-10 divide-y divide-ivory/10">
          {ITINERARY.map((day, i) => (
            <DayBlock key={day.day} day={day} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
